import styled from 'styled-components';
import { Popper, Paper } from '@material-ui/core';

export const StyledPopper = styled(Popper)`
  && {
    z-index: 2000;
    width: 412px;

    @media screen and (max-width: 690px) {
      width: 90%;
    }
  }  
`;


export const NoNotificationsWrapper = styled.div`
  min-height: 200px;
  width: 380px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.primary};
  svg {
    width: 60px;
    height: 60px;
  }
  p {
    color: ${({ theme }) => theme.colors.gray};
    font-size: 16px;
    font-weight: bold;
    margin: ${({ theme }) => theme.spacing * 2}px
  }
  @media screen and (max-width: 690px) {
    width: 100%;
  }
`;

export const StyledPaper = styled(Paper)`
  padding: ${({ theme }) => theme.spacing * 2}px ${({ theme }) => theme.spacing * 4}px;
`;


export const NotificationWrapper = styled.div`
  width: 390px;
  max-height: 500px;
  overflow-y: scroll;
  overflow-x: hidden;
  @media screen and (max-width: 690px) {
    width: 100%;
  }
  &::-webkit-scrollbar {
    width: 4px;
    margin-left: 8px;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 4px ${({ theme }) => theme.colors.lightGray}; 
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.lightGray};
    border-radius: 12px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: ${({ theme }) => theme.colors.mediumGray};
  }
`;

export const FlexWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  > p {
    margin: 0;
    font-size: 24px;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.gray};
  }
  > button {
    border: none;
    outline: none;
    color: ${({ theme }) => theme.colors.primary};
    padding: 0;
    background-color: unset;
    text-transform: uppercase;
    font-size: 10px;
    font-weight: bold;
    cursor: pointer;
  }
`;
